export enum ScanType {
  PALM = 'palm',
  FACE = 'face',
}

export enum ScanRatio {
  SQUARE = 'square',
  PORTRAIT = 'portrait',
}
